function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationIcon = function SvgLocationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 10",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.03.44A3.96 3.96 0 0 0 .04 4.38v.05a3.83 3.83 0 0 0 1.2 2.85C1.29 7.34 4 9.76 4 9.76s2.76-2.42 2.76-2.48a3.83 3.83 0 0 0 1.2-2.85A3.885 3.885 0 0 0 4.19.44zm0 5.13a1.14 1.14 0 1 1 1.14-1.14c0 .63-.51 1.14-1.14 1.14",
    style: {
      fill: "#bf000a",
      strokeWidth: 0
    }
  }));
};
export default SvgLocationIcon;